module.exports = __webpack_public_path__ + "static/media/inviting.98952179.png";